module.exports = __webpack_public_path__ + "static/media/avatar2Blue-without-border.b5c44d18.svg";